<template>
    <div>
        <card>
            <p slot="title">
                通知设置
            </p>
            <Form>
                <FormItem label="明日上课提醒:">
                    <CheckboxGroup v-model="clazz">
                        <Checkbox label="weixin">微信</Checkbox>
                        <Checkbox label="sms">短信</Checkbox>
                    </CheckboxGroup>
                </FormItem>

                <FormItem label="课程结束通知:">
                    <CheckboxGroup v-model="clazzComplete">
                        <Checkbox label="weixin">微信</Checkbox>
                        <Checkbox label="sms">短信</Checkbox>
                    </CheckboxGroup>
                </FormItem>

                <FormItem label="课程取消通知:">
                    <CheckboxGroup v-model="clazzCancel">
                        <Checkbox label="weixin">微信</Checkbox>
                        <Checkbox label="sms">短信</Checkbox>
                    </CheckboxGroup>
                </FormItem>

                <FormItem label="学生缴费通知:">
                    <CheckboxGroup v-model="recharge">
                        <Checkbox label="weixin">微信</Checkbox>
                        <Checkbox label="sms">短信</Checkbox>
                    </CheckboxGroup>
                </FormItem>

                <FormItem label="预约通知:">
                    <CheckboxGroup v-model="signup">
                        <Checkbox label="weixin">微信</Checkbox>
                        <Checkbox label="sms">短信</Checkbox>
                    </CheckboxGroup>
                </FormItem>

                <FormItem label="任务提醒:">
                    <CheckboxGroup v-model="taskNotify">
                        <Checkbox label="weixin">微信</Checkbox>
                        <Checkbox label="sms">短信</Checkbox>
                    </CheckboxGroup>
                </FormItem>

                <FormItem label="任务处理通知:">
                    <CheckboxGroup v-model="taskResult">
                        <Checkbox label="weixin">微信</Checkbox>
                        <Checkbox label="sms">短信</Checkbox>
                    </CheckboxGroup>
                </FormItem>

                <FormItem label="教师评价提醒:">
                    <CheckboxGroup v-model="classTeacherComment">
                        <Checkbox label="weixin">微信</Checkbox>
                        <Checkbox label="sms">短信</Checkbox>
                    </CheckboxGroup>
                </FormItem>


                <FormItem>
                    <Button type="primary" @click="saveNotifySetting">保存</Button>
                </FormItem>
            </Form>
        </card>
    </div>
</template>
<script>
  export default {
    name: 'setting_notify',
    data() {
      return {
        clazz: [],
        clazzComplete: [],
        clazzCancel: [],
        recharge: [],
        signup: [],
        taskNotify: [],
        taskResult: [],
        classTeacherComment: []
      }
    },
    computed: {},
    methods: {
      loadNotifySetting() {
        this.$api.setting.loadNotifySetting().then(resp => {
          if (resp.data.clazz.sms_flag) {
            this.clazz.push("sms");
          }
          if (resp.data.clazz.weixin_flag) {
            this.clazz.push("weixin");
          }
          if (resp.data.clazzComplete.sms_flag) {
            this.clazzComplete.push("sms");
          }
          if (resp.data.clazzComplete.weixin_flag) {
            this.clazzComplete.push("weixin");
          }
          if (resp.data.clazzCancel.sms_flag) {
            this.clazzCancel.push("sms");
          }
          if (resp.data.clazzCancel.weixin_flag) {
            this.clazzCancel.push("weixin");
          }
          if (resp.data.recharge.sms_flag) {
            this.recharge.push("sms");
          }
          if (resp.data.recharge.weixin_flag) {
            this.recharge.push("weixin");
          }
          if (resp.data.signup.sms_flag) {
            this.signup.push("sms");
          }
          if (resp.data.signup.weixin_flag) {
            this.signup.push("weixin");
          }

          if (resp.data.taskNotify.sms_flag) {
            this.taskNotify.push("sms");
          }
          if (resp.data.taskNotify.weixin_flag) {
            this.taskNotify.push("weixin");
          }

          if (resp.data.taskResult.sms_flag) {
            this.taskResult.push("sms");
          }
          if (resp.data.taskResult.weixin_flag) {
            this.taskResult.push("weixin");
          }

          if (resp.data.classTeacherComment.sms_flag) {
            this.classTeacherComment.push("sms");
          }
          if (resp.data.classTeacherComment.weixin_flag) {
            this.classTeacherComment.push("weixin");
          }

        });
      },
      saveNotifySetting() {
        this.$api.setting.saveNotifySetting({
          clazz: this.clazz,
          clazzComplete: this.clazzComplete,
          clazzCancel: this.clazzCancel,
          recharge: this.recharge,
          signup: this.signup,
          taskNotify: this.taskNotify,
          taskResult: this.signup,
          classTeacherComment: this.classTeacherComment,
        }).then(resp => {
          if (resp.state == 'ok') {
            this.$Message.info('保存成功');
          } else {
            this.$Message.error('保存失败');
          }
        });
      }
    },
    mounted: function () {
      this.loadNotifySetting();
    },
    activated() {
      // this.loadNotifySetting();
    },
  }
</script>
